import { uploadAsset } from "./storage/assetStore";

const ENGINE_SAMPLE_BASE =
  (import.meta.env.VITE_ENGINE_SAMPLE_URL as string | undefined) ??
  "https://play.pixadv.net/sample";

const STARTER_PATHS = [
  "bg/street.svg",
  "bg/park.svg",
  "chara/alice_normal.svg",
  "chara/alice_smile.svg",
  "chara/alice_sad.svg",
  "chara/alice_happy.svg",
  "face/alice_normal.svg",
  "face/alice_smile.svg",
  "face/alice_sad.svg",
  "face/alice_happy.svg",
];

export interface StarterAssetProgress {
  done: number;
  total: number;
  currentPath: string | null;
}

/**
 * 新規プロジェクトに、Engine のサンプル SVG アセットを一括アップロードする。
 * 失敗してもエラーにしない(個別失敗はログ警告のみ)。
 */
export async function bundleStarterAssets(
  projectId: string,
  onProgress?: (p: StarterAssetProgress) => void,
): Promise<void> {
  let done = 0;
  for (const path of STARTER_PATHS) {
    onProgress?.({ done, total: STARTER_PATHS.length, currentPath: path });
    try {
      const res = await fetch(`${ENGINE_SAMPLE_BASE}/${path}`);
      if (res.ok) {
        const blob = await res.blob();
        const mime = blob.type || "image/svg+xml";
        await uploadAsset(projectId, path, blob, mime);
      } else {
        console.warn(`[starter] ${path} fetch failed: ${res.status}`);
      }
    } catch (e) {
      console.warn(`[starter] ${path} failed:`, e);
    }
    done++;
  }
  onProgress?.({ done, total: STARTER_PATHS.length, currentPath: null });
}
